module.exports = __webpack_public_path__ + "static/img/compass.169c338.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/bg/compass.jpg
// module id = JvbE
// module chunks = 4